import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, formatErr } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=unauth, obj=authed
  const [company, setCompany] = useState(null);

  const refreshCompany = useCallback(async () => {
    try {
      const { data } = await api.get("/companies/current");
      setCompany(data || null);
    } catch {
      setCompany(null);
    }
  }, []);

  const loadMe = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      await refreshCompany();
    } catch {
      setUser(false);
      setCompany(null);
    }
  }, [refreshCompany]);

  useEffect(() => {
    loadMe();
  }, [loadMe]);

  const login = async (email, password) => {
    try {
      const { data } = await api.post("/auth/login", { email, password });
      if (data.token) localStorage.setItem("lb_token", data.token);
      setUser(data);
      await refreshCompany();
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatErr(e.response?.data?.detail) || e.message };
    }
  };

  const register = async (name, email, password) => {
    try {
      const { data } = await api.post("/auth/register", { name, email, password });
      if (data.token) localStorage.setItem("lb_token", data.token);
      setUser(data);
      await refreshCompany();
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatErr(e.response?.data?.detail) || e.message };
    }
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("lb_token");
    setUser(false);
    setCompany(null);
  };

  return (
    <AuthContext.Provider value={{ user, company, login, register, logout, refreshCompany, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
